import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { AUTH_ROUTES } from "@/src/auth/constants/auth-routes";
import { POST_ROUTES } from "@/src/post/constants/post-routes";
import { CtaLink } from "../atoms/cta-link";
import { SectionHeading } from "../atoms/section-heading";

interface LandingFinalCtaSectionProps {
	communityName: string;
	isAuthenticated: boolean;
}

export function LandingFinalCtaSection({ communityName, isAuthenticated }: LandingFinalCtaSectionProps) {
	const { t } = useTranslation("community");

	return (
		<section className="landing-bg-dark-hero relative overflow-hidden py-24 md:py-32">
			<div className="landing-bg-grid absolute inset-0 opacity-50" aria-hidden />
			<div className="relative mx-auto flex w-full max-w-4xl flex-col items-center gap-10 px-6">
				<SectionHeading
					title={t("landing.final_cta.title", { communityName })}
					description={t("landing.final_cta.description")}
					tone="white"
				/>
				<CtaLink to={isAuthenticated ? POST_ROUTES.FEED : AUTH_ROUTES.AUTH} variant="white" size="lg" endContent={<ArrowRight size={18} />}>
					{isAuthenticated ? t("landing.final_cta.button_auth") : t("landing.final_cta.button_guest")}
				</CtaLink>
			</div>
		</section>
	);
}
